import React, { FC } from 'react';
import { ProjectTypeSelectProps } from './ProjectTypeSelectProps';
import Choice, { ChoiceItem } from '@ingka/choice';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import { createProjectType, onProjectTypeClick, projectTypes } from './utils';
import useTranslation from '../../hooks/useTranslation';

const ProjectTypeSelect: FC<ProjectTypeSelectProps> = ({
  closeCreateModal,
  handleOpenCreateNewUnitModal,
  handleOpenCreateImproveModal,
  handleOpenFormatChangeModal,
  handleOpenRelocationModal,
  handleOpenCloseProjectModal,
  startAction,
}) => {
  const t = useTranslation();
  return (
    <Stack py={2} px={5} spacing={3} data-testid={'create-new-project-modal'}>
      <Text textStyle="Heading.S" tagName="h3">
        {t('message.projectType')}
      </Text>
      <Choice>
        {projectTypes.map((projectT: createProjectType) => (
          <ChoiceItem
            data-testid={projectT.id}
            key={projectT.id}
            id={projectT.id}
            caption={t(projectT.caption)}
            image={null}
            imagePosition="leading"
            onClick={() => {
              closeCreateModal();
              onProjectTypeClick(
                projectT.id,
                handleOpenCreateNewUnitModal,
                handleOpenCreateImproveModal,
                handleOpenFormatChangeModal,
                handleOpenRelocationModal,
                handleOpenCloseProjectModal,
                startAction,
              );
            }}
            paymentLogo={null}
            title={t(projectT.title)}
          />
        ))}
      </Choice>
    </Stack>
  );
};

export default ProjectTypeSelect;
